import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@achieve/ascend'
import { X } from 'react-feather'

export const AdvertisingDisclosures = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleDialogClose = () => {
    setIsDialogOpen(false)
  }

  return (
    <>
      <Button onClick={() => setIsDialogOpen(true)} variant="text" className="text-sm">
        Advertising Disclosures
      </Button>

      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-info-title"
        aria-describedby="alert-dialog-info-description"
      >
        <DialogTitle>Advertising Disclosures</DialogTitle>
        <IconButton
          onClick={handleDialogClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8,
          })}
        >
          <X className="text-gray-500" />
        </IconButton>
        <DialogContent className="pb-8">
          <DialogContentText gutterBottom className="font-bold">
            You are our top priority... always!
          </DialogContentText>
          <DialogContentText gutterBottom>
            At Bills.com, our goal is to help you make better-informed financial decisions and be
            confident in the decisions you make. We do this by creating and offering to you free of
            charge relevant, highly curated content and working with lenders and other providers of
            products and services (“Service Providers”) to present you with options based on your
            individual needs and circumstances.
          </DialogContentText>
          <DialogContentText gutterBottom>
            We do not collect any fees or compensation from consumers; rather, we are affiliated
            with and/or compensated by the Service Providers that participate on our website. These
            Service Providers, not us, take applications; make credit decisions; offer, originate
            and make loans; negotiate loan terms; and/or offer debt settlement services. Our list of
            Service Providers, below, is neither exhaustive nor are the products and services they
            offer available in all states.
          </DialogContentText>
          <DialogContentText gutterBottom className="font-bold mt-4">
            Bills.com Approved Provider Network:
          </DialogContentText>
          <DialogContentText>
            - Freedom Financial Asset Management, LLC, d/b/a FreedomPlus
          </DialogContentText>
          <DialogContentText>- Freedom Resolution</DialogContentText>
          <DialogContentText>- Achieve Loans, a d/b/a of Lendage, LLC</DialogContentText>
          <DialogContentText>- QuinStreet, Inc.</DialogContentText>
          <DialogContentText>- Even Financial, Inc.</DialogContentText>
          <DialogContentText>- Credit Operations, Inc.</DialogContentText>
          <DialogContentText>- Financial Health Network</DialogContentText>
          <DialogContentText>- HSH.com, LLC</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  )
}
